import Layout from "components/Layout";
import SEO from "components/Seo";
import "styles/catalog.css";
import { SettingsTabs } from "./Settings.Tabs";
import { ICredentialInfo } from "types/stac";

interface SettingsPageProps {
  credentials?: ICredentialInfo[];
  isLoading: boolean;
  onNextPage: () => void;
  onPreviousPage: () => void;
  onPageChange: (size: number) => void;
}

export const SettingsPage = ({
  credentials = [],
  isLoading = false,
  onNextPage,
  onPreviousPage,
  onPageChange,
}: SettingsPageProps) => {
  return (
    <Layout isShort>
      <SEO title="Settings" />

      <div className="grid-content">
        <h2>Settings</h2>
        <SettingsTabs
          credentials={credentials}
          isLoading={isLoading}
          onNextPage={onNextPage}
          onPreviousPage={onPreviousPage}
          onPageChange={onPageChange}
        />
      </div>
    </Layout>
  );
};
